export default __webpack_public_path__ + "static/media/current_score.97fb58c3.svg";